t = require('views/internal/teacup-with-helpers')('ad_business_class')

module.exports = ->
  t.format 'check-out-business-class'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/ad_business_class.coffee